import { render, staticRenderFns } from "./InstagramPost.vue?vue&type=template&id=0ab0aaaa&scoped=true"
import script from "./InstagramPost.vue?vue&type=script&lang=ts"
export * from "./InstagramPost.vue?vue&type=script&lang=ts"
import style0 from "./InstagramPost.vue?vue&type=style&index=0&id=0ab0aaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0aaaa",
  null
  
)

export default component.exports